import { createAction, props } from '@ngrx/store';
import { LoadsAgenda } from 'src/app/pages/orders/delivery-schedule/components/graph-delivery-schedule/models/graph-delivery-schedule.model';

export const loadDeliverySchedule = createAction('[DeliverySchedule] Load', props<{ key: string }>());

export const loadDeliveryScheduleSuccessByKey = createAction(
  '[DeliverySchedule] Load Success By Key',
  props<{ key: string; response: LoadsAgenda }>(),
);

export const loadDeliveryScheduleFailure = createAction(
  '[DeliverySchedule] Load Failure',
  props<{ key: string; error: any }>(),
);

// Reset the entire DeliverySchedule state to initial
export const resetDeliveryScheduleState = createAction('[DeliverySchedule] Reset State');
